import React from "react";
import { Box } from "@mui/material";

// Fondo blanco para los botones y el formulario de tarjeta de PayPal. Se dibujan
// en un iframe de PayPal con texto oscuro fijo y fondo transparente: no se pueden
// recolorear desde acá y, sobre los temas oscuros, el texto no se lee.
const PayPalSurface = ({ children }) => (
  <Box sx={{ width: "100%", boxSizing: "border-box", p: 1.5, borderRadius: "12px", bgcolor: "#ffffff", colorScheme: "light" }}>
    {children}
  </Box>
);

export default PayPalSurface;
